var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"main-container"},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-card',{staticClass:"pa-5",attrs:{"tile":"","flat":"","color":"transparent"}},[_c('AllSendEmailTabs')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }